/**
 * Nav colour/fabric swatch thumbnails are emitted inside <template data-nav-swatch> so they
 * are inert and never fetched during initial page load. See snippets/nav-color-swatch.liquid
 * for the measurements. Clone them in on the first menu interaction, then stop.
 */
(() => {
  let done = false;

  const hydrate = () => {
    if (done) return;
    const t = document.querySelectorAll('template[data-nav-swatch]');
    if (!t.length) return;
    done = true;
    t.forEach((tpl) => tpl.parentNode.replaceChild(tpl.content.cloneNode(true), tpl));
    document.dispatchEvent(new CustomEvent('nav-swatch:hydrated'));
  };

  const TRIGGERS = '[data-drawer-toggle],.mobile-menu,.site-header__menu,' +
    '[aria-controls*="drawer"],.top-level-nav__item,.mobile-navlink,.navlink';

  const bind = () => document.querySelectorAll(TRIGGERS).forEach((el) => {
    if (el.dataset.swBound) return;
    el.dataset.swBound = 'true';
    ['pointerdown', 'focusin', 'mouseenter'].forEach((ev) =>
      el.addEventListener(ev, hydrate, { once: true }));
  });

  const init = () => {
    bind();
    // any drawer/menu opening is a hydrate signal, however it was triggered
    new MutationObserver((recs) => {
      for (const r of recs) {
        const cl = r.target.classList;
        if (cl && (cl.contains('js-drawer-open') || cl.contains('is-open') ||
                   cl.contains('drawer--is-open'))) { hydrate(); return; }
      }
      bind();
    }).observe(document.documentElement,
      { attributes: true, attributeFilter: ['class'], subtree: true, childList: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else init();
  document.addEventListener('shopify:section:load', bind);
})();
